"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCOUNT_ALERTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACCOUNT_ALERTS;
  }
});
Object.defineProperty(exports, "ANALYTICS_ROI_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ANALYTICS_ROI_TRACKING;
  }
});
Object.defineProperty(exports, "A_B_TESTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.A_B_TESTING;
  }
});
Object.defineProperty(exports, "BID_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BID_MANAGEMENT;
  }
});
Object.defineProperty(exports, "BUDGET_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BUDGET_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CAMPAIGN_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CAMPAIGN_MANAGEMENT;
  }
});
Object.defineProperty(exports, "CONVERSION_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CONVERSION_TRACKING;
  }
});
Object.defineProperty(exports, "KEYWORD_RESEARCH", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.KEYWORD_RESEARCH;
  }
});
Object.defineProperty(exports, "KEYWORD_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.KEYWORD_TRACKING;
  }
});
Object.defineProperty(exports, "LANDING_PAGES_WEB_FORMS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LANDING_PAGES_WEB_FORMS;
  }
});
Object.defineProperty(exports, "URL_BUILDER", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.URL_BUILDER;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/PPC.js
// module id = 577
// module chunks = 209 210 211 212 213